import { Component } from '@angular/core';
import { APPCONFIG } from '../../config'

@Component({
    selector: 'my-app-search-overlay',
    styles: [],
    template: require('./search-overlay.component.html')
})

export class AppSearchOverlayComponent {

}
